import { Group } from '@mantine/core';
import { trackEvent } from '@repo/common/analytics';
import { Button } from '@repo/foundations';
import { lowerCase } from 'lodash-es';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { useAuthUser } from '../../../../api';

import { entityModalStore } from '../../store';

function MetricFooter() {
	const { user, workspace } = useAuthUser();
	const navigate = useNavigate();

	const handleOnClick = () => {
		trackEvent('metric/create', {}, user, workspace);
		entityModalStore.createMetric(navigate);
	};

	return (
		<Group position="right">
			<Button
				onClick={handleOnClick}
				loading={entityModalStore.loading}
				variant="primary"
			>
				Create {lowerCase(entityModalStore.type)}
			</Button>
		</Group>
	);
}

const MetricFooterObserver = observer(MetricFooter);
export default MetricFooterObserver;
